<ng-container *ngIf="items && items.length > 0">
  <h2 data-test="6fq7zNiE">{{ title }}</h2>
  <table data-test="RfnC1r1H" class="document__table items-table items-table_light">
    <tr data-test="7Vl1eF9U" class="items-table__header items-table__header_fs-9">
      <th data-test="jd7Decwc">task name</th>
      <th data-test="sPyjo9Ri">description</th>
      <th data-test="M-9xaUi7">billable price</th>
      <th data-test="hwS5cDIa">quantity</th>
      <th data-test="eg6tljck">amount</th>
    </tr>
    <tr data-test="vvoeJZgt" class="row-type" *ngFor="let task of items; index as i">
      <td data-test="CmEOh_Q3">
        <b data-test="yBfkO8TR">{{ task.name }}</b>
      </td>
      <td data-test="EyJnGbB5">{{ task.description }}</td>
      <td data-test="qnwlA_Xl" class="text-right text-nowrap">
        <span data-test="Hyjtp8-a" class="text-light">{{ currencySign }}</span>
        {{ task.billablePrice | fromCents | companyCurrency }}
      </td>
      <td data-test="UeK7srSg" class="text-right text-nowrap">
        {{ task.qty }}
      </td>
      <td data-test="4lngfxde" class="text-right text-nowrap pr-2">
        <span data-test="teOg8OEa" class="text-light">{{ currencySign }}</span>
        {{ task.amount | fromCents | companyCurrency }}
      </td>
    </tr>
  </table>

  <div data-test="0fcn1zBe" class="pr-2 text-right h3">
    Total:
    <span data-test="5t-EViyf" class="text-light">{{ currencySign }}</span>
    {{ total | fromCents | companyCurrency }}
  </div>
</ng-container>
